<template>
  <v-container class="fill-height d-flex align-center justify-center">
    <v-row justify="center">
      <v-col 
        cols="12" 
        md="6"
      >
        <v-alert
          type="warning"
          border="start"
          elevation="2"
          prominent
          title="404 - Página no encontrada"
          text="La página que buscas no existe o ha sido movida."
        />
        <div class="text-center mt-4">
          <v-btn 
            color="primary"
            @click="$router.push('/')"
          >
            Volver al inicio
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
